// extracted by mini-css-extract-plugin
export default {"root":"CodeBlock_root__c3nqh"};